import { Routes, Route, Navigate } from "react-router";
import MediaLibraryPage from "./media";
import SitesPage from "./sites";
import PageEditorPage from "./editor";
import FormsPage from "./forms";
import PagesPerformancePage from "./performance";
import SiteSettingsPage from "./site-settings";
import SiteThemePage from "./theme";
import AiGeneratePage from "./ai-generate";
import AbTestingPage from "./ab-testing";
import NewPageEntry from "./new-page";
import PageReviewPage from "./review";
import StreamingGenerator from "@/pages/page-builder/streaming-generator";
import ConversationalBuilder from "@/pages/page-builder/conversational-builder";

export default function PagesPage() {
  return (
    <Routes>
      <Route index element={<Navigate to="new" replace />} />
      <Route path="sites" element={<SitesPage />} />
      <Route path="new" element={<NewPageEntry />} />
      <Route path="new-page" element={<Navigate to="/pages/new" replace />} />
      <Route path="media" element={<MediaLibraryPage />} />
      <Route path="editor/:pageId" element={<PageEditorPage />} />
      <Route path="editor/:pageId/review" element={<PageReviewPage />} />
      <Route path="forms" element={<FormsPage />} />
      <Route path="performance" element={<PagesPerformancePage />} />
      <Route path="theme" element={<SiteThemePage />} />
      <Route path="settings" element={<SiteSettingsPage />} />
      <Route path="ai-generate" element={<AiGeneratePage />} />
      <Route path="ab-testing" element={<AbTestingPage />} />
      <Route path="streaming-generator" element={<StreamingGenerator />} />
      <Route path="conversational-builder" element={<ConversationalBuilder />} />
    </Routes>
  );
}
